module.exports = __webpack_public_path__ + "media/images/icons/credit_card_front-232aca6fd65c7dc630217ea292086ca6.svg";